import React from "react";
import Icon from "../../../components/Icon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan, faCheck} from "@fortawesome/free-solid-svg-icons";
import { Button } from "reactstrap";

const ChatSidebar = ({ active, closeSidebar, heading, children, user = '', onChangeLeadUsage }) => {
	return (
		<aside className={`chat-sidebar ${active ? "chat-sidebar--active" : ""}`}>
			<header className="header chat-sidebar__header">
				<button onClick={closeSidebar}>
					<Icon id="cancel" className="chat-sidebar__header-icon" />
				</button>
				<h2 className="chat-sidebar__heading"> {heading}</h2>
				{
					heading === "Contact Info" &&
					<div className={``}>
						<Button color={ user["wsapp_blocked"] === "Yes"  ? "success" : "danger"} onClick={() => onChangeLeadUsage(user.cid)}>
						<FontAwesomeIcon icon={user["wsapp_blocked"] === "Yes" ? faCheck : faBan}/>
							{ user["wsapp_blocked"] === "Yes" ? " Unblock" : " Block" }
						</Button>					
					</div>
				}
			</header>
			<div className="chat-sidebar__content">{children}</div>
		</aside>
	);
};

export default ChatSidebar;
